export default __webpack_public_path__ + "static/media/Howitworks3.e08696cd.png";